import PropTypes from 'prop-types';
import React, { forwardRef, memo, useCallback } from 'react';
import MenuItem from '../../Menu/MenuItem';
const TabMenuItem = /*#__PURE__*/ forwardRef(({ active, disabled, hideable, label = '', opened, onClick, index, ...other }, ref)=>{
    const handleClick = useCallback(()=>{
        if (disabled || active && !hideable) {
            return;
        }
        onClick(index);
    }, [
        disabled,
        active,
        onClick,
        index,
        hideable
    ]);
    const icon = opened ? 'angleUp' : 'angleDown';
    return /*#__PURE__*/ React.createElement(MenuItem, {
        ref: ref,
        label: label,
        onClick: handleClick,
        isActive: ()=>active,
        icon: hideable && active ? icon : null,
        ...other
    });
});
TabMenuItem.displayName = 'forwardRef(TabMenuItem)';
TabMenuItem.propTypes = {
    /**
	 * True if this tab is currently selected
	 */ active: PropTypes.bool,
    /**
	 * Whether is tab clickable
	 */ disabled: PropTypes.bool,
    /**
	 * True if tab is allowed to hide
	 */ hideable: PropTypes.bool,
    /**
	 * Position of tab
	 */ index: PropTypes.number.isRequired,
    /**
	 * Label of the menu item, can be string or component
	 */ label: PropTypes.node.isRequired,
    /**
	 * Action which is called after click on label
	 */ onClick: PropTypes.func.isRequired,
    /**
	 * Whether is tab opened or closed
	 */ opened: PropTypes.bool
};
export default /*#__PURE__*/ memo(TabMenuItem);
